import React from 'react';
import { Box, FormControl, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';

import { V2_PAYMENT_TYPE } from '../services/checkout';

/**
 * Checkout payment method (V2): COD or online (Cashfree on the next step).
 * @param {{ value: string, onChange: (value: string) => void }} props
 */
export default function CheckoutPaymentSelect({ value, onChange }) {
  return (
    <Box>
      <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 0.5 }}>
        Payment method
      </Typography>
      <FormControl component="fieldset" fullWidth>
        <RadioGroup
          name="v2-payment-type"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        >
          <FormControlLabel
            value={V2_PAYMENT_TYPE.COD}
            control={<Radio size="small" />}
            label={
              <Box sx={{ py: 0.25 }}>
                <Typography variant="body2" fontWeight={600}>
                  Cash on delivery (COD)
                </Typography>
              </Box>
            }
            sx={{
              alignItems: 'flex-start',
              m: 0,
              p: 1.5,
              mb: 1.5,
              border: '1px solid',
              borderColor: 'divider',
              alignItems: 'center',
              borderRadius: 2,
              width: '100%',
              boxSizing: 'border-box',
              '&:last-of-type': { mb: 0 },
            }}
          />
          <FormControlLabel
            value={V2_PAYMENT_TYPE.ONLINE}
            control={<Radio size="small" />}
            label={
              <Box sx={{ py: 0.25 }}>
                <Typography variant="body2" fontWeight={600}>
                  Pay online (UPI, card, Net Banking)
                </Typography>
              </Box>
            }
            sx={{
              alignItems: 'flex-start',
              m: 0,
              p: 1.5,
              border: '1px solid',
              borderColor: 'divider',
              alignItems: 'center',
              borderRadius: 2,
              width: '100%',
              boxSizing: 'border-box',
            }}
          />
        </RadioGroup>
      </FormControl>
    </Box>
  );
}
